<template>
    <div>
        <!--<slot></slot>-->
        <div class="">
            <!--<div class="col col-3 col-md-2">-->
                <!--&lt;!&ndash;<button type="button" class="btn btn-info btn-smXall btn-search " v-on:click="clickToSearch">&ndash;&gt;-->
                <!--&lt;!&ndash;<i class="fa fa-search"></i> Keresés&ndash;&gt;-->
                <!--&lt;!&ndash;</button>&ndash;&gt;-->
            <!--</div>-->
            <!--<div class="buyerInputsContainer col col-3 col-md-4 col-xs-3 extensionLine"><label for="buyerSearcherSid" class=" form-control-label font-size-large">-->
                <!--<small>{{$t('buyerSearcher.buyerId')}}</small>-->
            <!--</label></div>-->
            <!--col col-6 col-md-6-->
            <div class="buyerInputsContainer ">
                <div class="input-group">

                    <template v-if="justDisplay==='false'">

                    <div class="input-group-btn" v-if="buyer.id" v-on:click="buyerDisplayerOn"><span class="btn btn-success"><i class="fa fa-user"></i></span></div>
                    <div class="input-group-btn" v-if="!buyer.id" v-on:click="buyerDisplayerOn"><span class="input-group-addon btn btn-secondary"><i class="fa fa-user"></i></span></div>

                    <a style="flex: 0.01 1;" class="btn_keyboard input-group-addon" v-on:click="clickToOpenKeyboard" v-if="justDisplay=='false'">
                        <div class=" "><i class="fa fa-keyboard-o"></i></div>
                    </a>
                    </template>

                    <template v-if="buyerDisplayer">
                        <input class="form-control" readonly :value="buyerData" v-on:click="buyerDisplayerOff" >

                    </template>
                    <template v-if="!buyerDisplayer">

                        <InputText :title="$t('buyerSearcher.buyerId')" style="flex: 1 1 0;" :disabled="disabled" :readonly="readonly" id="buyerSearcherSid" className="form-control " isAccept="true"
                                   isChange="true" :hasToKeyboard="hasKeyboard" :value="sid" v-model="sid" placeholder="" dataLayout="t" :onblur="onblur"/>

                    </template>


                    <a style="flex: 0.01 1;" class="btn_del_input input-group-addon pointer" data-id="0" v-on:click="clickToClear" v-if="justDisplay=='false'">
                        <div class=" "><i class="fa fa-times"></i></div>
                    </a>

                    <template v-if="buyer.discount">
                        <div style="flex: 0.02 0 0;" class="input-group-addonX discount_type_container discount_type btn btn-danger ">{{buyer.discount}}<span v-if="buyer.discount">%</span></div>
                    </template>
                    <template v-if="!buyer.discount">
                        <div style="flex: 0.02 0 0;" class="input-group-addon discount_type_container discount_type">{{buyer.discount}}<span v-if="buyer.discount">%</span></div>
                    </template>

                </div>
            </div>
            <!--col-9-->
            <!--<div class="">-->
                <!--<input type="text" id="searchText" name="searchText" placeholder="" class="form-control search d-none">-->
                <!--<label class="buyerData">{{buyerData}}</label>-->
            <!--</div>-->
        </div>
        <!--<div class="row searchResultContainer">-->
        <!--<div class=" searchResult d-none">-->
        <!--<table class="datatablex Xdisplay  table Xtable-striped Xtable-bordered" style="width: 100%"></table>-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import i18n from '@/i18n';
    import Helper from '@/helper/Helper';
    import InputText from '@/components/InputText.vue';
    import Api from '@/api/Api';

    export default {
        name: 'BuyerSearcher',
//        roles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        data() {
            return {
                data: {
//                    sid: "1"
                },
                sid: "",
                buyer: {},
                buyerData: "",
                hasKeyboard: "false",
                disabled: "false",
                readonly: "false",
                buyerDisplayer: false,
            };
        },
        watch: {
            sid: function (newValue, oldValue) {
                const modul = this;
                modul.hasKeyboard = "false";

                if(modul.timer){
                    clearTimeout(modul.timer);
                }
                modul.timer=setTimeout(function () {
                    if (newValue&& newValue!==oldValue) {
                        modul.sid = modul.sid.replace(/ö/g, '0');
                    }
                },300);



                modul.getBuyerBySid(function (err, res) {
                    console.log("getBuyerBySid");
                    if (res ) { // && res[0] && res[0]
                        const buyerData = res;
                        modul.buyer = buyerData;
                        if(localStorage.getItem("lang")==="hu"){
                            modul.buyerData = // buyerData.pre_name + " " +
                                buyerData.last_name  + " " + buyerData.first_name
                            // + " " + buyerData.zip_code + " " + buyerData.address + " " + buyerData.phone + " " + buyerData.email + " ";
                        } else {
                            modul.buyerData = // buyerData.pre_name + " " +
                                buyerData.first_name + " " + buyerData.last_name
                            // + " " + buyerData.zip_code + " " + buyerData.address + " " + buyerData.phone + " " + buyerData.email + " ";
                        }
                        modul.$eventBus.$emit('globalSetBuyer', res);
                        modul.buyerDisplayer=true;
                    } else {
                        modul.buyer = {};
                        modul.buyerData = "";
                        modul.$eventBus.$emit('globalSetBuyer', {});
                        modul.buyerDisplayer=false;
                    }
                }, newValue);
                if (modul.justDisplay === "true") {
                    modul.disabled = "true";
                    modul.readonly = "true";
                }
            }
        },
        props: {
            justDisplay: {
                type: String,
                default: "false",
            },
        },
        mounted() {
            const modul = this;
            console.log("BasketDisplayer");
            if (modul.justDisplay === "false") {
                modul.$eventBus.$on('globalReadBuyerSid', this.globalReadBuyerSidEventHandler);
            }
            modul.$eventBus.$on('globalSetBuyerSid', this.globalReadBuyerSidEventHandler);
        },
        beforeDestroy() {
            const modul = this;
            if (modul.justDisplay === "false") {
                this.$eventBus.$off('globalReadBuyerSid');
            }
            this.$eventBus.$off('globalSetBuyerSid');
        },
        methods: {
            globalReadBuyerSidEventHandler(sid){
                const modul = this;
                modul.sid = sid;
            },
            onblur(e){
                const modul = this;
                console.log(e)

                setTimeout(function (e) {
                    if(document.getElementById('buyerSearcherSid')!==document.activeElement){
                        modul.buyerDisplayerOn()
                    };
                }, 300);

            },
            buyerDisplayerOff(){
                const modul = this;
                if(modul.justDisplay!=="false"){ return ;}
                modul.buyerDisplayer=false;
                setTimeout(function (e) {
                    document.getElementById('buyerSearcherSid').focus();
                }, 200);
            },
            buyerDisplayerOn(){
                const modul = this;
                if(modul.justDisplay!=="false"){ return ;}
                if(modul.buyer.id){
                    modul.buyerDisplayer=true;
                }
            },
//            clickToSearch(e){
//                console.log("clickToSearch");
//                const modul = this;
//                e.preventDefault();
//                console.log("clickToSearch clicked");
//            },
            clickToOpenKeyboard(e){
                console.log("clickToOpenKeyboard");
                const modul = this;
                e.preventDefault();
                modul.buyerDisplayer = false;
                modul.hasKeyboard = "true";
                setTimeout(function (e) {
                    document.getElementById('buyerSearcherSid').focus();
                }, 200);
            },
            clickToClear(e){
                const modul = this;
                modul.buyerDisplayerOff();
                console.log("clickToClear");
                modul.buyer = {};
                modul.sid = "-";
                modul.buyerData = "";
                setTimeout(function (e) {
                    modul.sid = "";
                }, 0);
                e.preventDefault();
            },
            /**
             * Kerső - BAL felület miatt
             * @param cb
             * @param srcText
             */
            getBuyers: function (cb, srcText) {
                if (srcText) {
                    window.db.select(function (err, res) {
                            cb(err, window.db.convertResToArray(err, res))
                        }, "buyer", "*"
                        , 'where (gender like ' + window.db.quote(srcText) + ' OR pre_name like ' + window.db.quote(srcText) + ' OR first_name like ' + window.db.quote(srcText) + ' OR last_name like ' + window.db.quote(srcText) + ' OR born_year like ' + window.db.quote(srcText) + ' OR zip_code like ' + window.db.quote(srcText) + ' OR email like ' + window.db.quote(srcText) + ' OR phone like ' + window.db.quote(srcText) + ' OR address like ' + window.db.quote(srcText) + ' OR company like ' + window.db.quote(srcText) + ' OR sid like ' + window.db.quote(srcText) + ' OR discount like ' + window.db.quote(srcText) + ' OR text like ' + window.db.quote(srcText) + ') AND deleted = 0'
                    );
                } else {
                    window.db.select(function (err, res) {
                        cb(err, window.db.convertResToArray(err, res))
                    }, "buyer", "*", "(`deleted` = 0 OR `deleted` = '0')");
                }
            },
            /**
             * Datatable miatt
             * @param cb
             * @param id
             */
            getBuyer: function (cb, id) {
                window.db.select(
                    function (err, res) {
                        cb(err, window.db.convertResToArray(err, res))
                    }
                    , "buyer", "*", "(id=" + id + " OR id=" + Number(id) +") AND (`deleted` = 0 OR `deleted` = '0')");
            },
            /**
             * SID alapján a törzsvásárló kitöltése
             * @param cb
             * @param sid
             */
            getBuyerBySid: function (cb, sid) {
              Api.getBuyerBySid({id:sid}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null,e.data);
                }
              },function (err) {
                console.log(err)
                cb(err,null);
              });
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "buyer", "*", "sid=" + window.db.quote(sid) + " AND (`deleted` = 0 OR `deleted` = '0')");
            },
        },
        components: {
            InputText,
        },
    };
</script>

<style >
    input#buyerSearcherSid {
        display: block;
        width: 100%;
        /*border: 0;*/
        /*padding: 0;*/
    }
    .buyerInputsContainer{
        position: relative;
        top:0;
        left:0;
    }
</style>

